import styles from "@/components/common/voice-selector/top-bars/styles/voice-blending-top-bar.module.scss";
import DefaultTopBar, {
  DefaultTopBarProps,
} from "@/components/common/voice-selector/top-bars/default-top-bar";
import UnfilledButton from "@/components/common/unfilled-button";
import { BlendingCompatibilityCategory } from "@/components/common/voice-selector/hooks/use-blending-voice-select";
import WarningText from "@/components/common/warning-text";

interface VoiceBlendingTopBarProps extends DefaultTopBarProps {
  isCompatible: boolean;
  compatibilityCategories?: BlendingCompatibilityCategory[];
  isCategorySelected: (category: BlendingCompatibilityCategory) => boolean;
  handleCategoryClick: (category: BlendingCompatibilityCategory) => void;
}

const VoiceBlendingTopBar = ({
  handleGenderSelect,
  handleFilterSelect,
  handleSearch,
  scrollY,
  isCompatible,
  compatibilityCategories,
  isCategorySelected,
  handleCategoryClick,
}: VoiceBlendingTopBarProps) => {
  return (
    <div className={styles.wrapper}>
      <DefaultTopBar
        handleGenderSelect={handleGenderSelect}
        handleFilterSelect={handleFilterSelect}
        handleSearch={handleSearch}
        scrollY={scrollY}
      />
      {compatibilityCategories && (
        <div className={styles.content_wrapper}>
          <div className={styles.compatibility_categories_container}>
            {compatibilityCategories.map((category) => (
              <UnfilledButton
                key={category.name}
                text={category.name}
                textColor={"#FFFFFF"}
                onClick={() => handleCategoryClick(category)}
                borderColor={
                  isCategorySelected(category) ? "#FF5722" : "#3F3F3F"
                }
              />
            ))}
          </div>
          {!isCompatible && (
            <WarningText text={"You may not like the result"} />
          )}
        </div>
      )}
    </div>
  );
};

export default VoiceBlendingTopBar;
